<template lang="pug">
  #ListGroup
    .table-view
      .table-view-header
        .table-view-header-title
          h3 Grupos de Empresas
        .table-view-header-actions
          b-button.btn-create(v-b-modal.create-group-modal size="sm" variant="secondary") + Nuevo
      b-table(:items="businessGroups" :fields="fields" responsive)
        template(v-slot:cell(actions)="{ item }")
          .table-actions
            b-button(:to="{ name: 'BusinessGroupDetail', params: { groupId: item.id} }" size="sm" variant="light" style="color: #7F828F")
              font-awesome-icon(:icon="['far', 'edit']" size="lg")
            b-button(@click="onDelete(item)", size="sm", variant="light" style="color: #7F828F")
                font-awesome-icon(:icon="['far', 'trash-alt']" size="lg")
    //- Modales
    b-modal#create-group-modal(title="Crear Grupo" hide-footer)
      GroupForm(@close="$bvModal.hide('create-group-modal')" @done="$bvModal.hide('create-group-modal'), fetchData()")
</template>
<script>
import { mapActions, mapGetters } from 'vuex';
import GroupForm from './GroupForm';
export default {
  components: {
    GroupForm
  },
  data() {
    return {
      fields: [
        {
          label: 'Nombre',
          key: 'name',
          sortable: true
        },
        {
          label: 'Descripción',
          key: 'description',
          sortable: true
        },
        {
          label: 'Acciones',
          key: 'actions',
        }
      ]
    }
  },
  async created() {
    this.fetchData()
  },
  computed: {
    ...mapGetters(['businessGroups'])
  },
  methods: {
    ...mapActions(['listBusinessGroups', 'deleteBusinessGroup']),
    fetchData () {
      this.listBusinessGroups()
    },
    showCreateModal() {
      this.showCreate = true;
    },
    async onDelete (group) {
      const ok = await this.$bvModal.msgBoxConfirm(`¿Está seguro que desea eliminar el grupo ${group.name}?`, {
        title: 'Eliminar Grupo',
        okTitle: 'Eliminar',
        okVariant: 'danger'
      })

      if (ok) {
        const response = await this.deleteBusinessGroup({ groupId: group.id })
        this.$root.$bvToast.toast(response.ok ? 'Grupo eliminado correctamente' : 'Error al eliminar el Grupo', 
        {
          title: response.ok ? 'Éxito!' : 'Ocurrió un error!',
          variant: response.ok ? 'success' : 'danger'
        })
        if (response.ok) {
          this.fetchData()
        }
      }
    }
  }
}
</script>
